import { type IntlShape } from "react-intl";
import { z } from "zod";

import { baseRoutes } from "@/api/base-routes";
import {
	type Corrugate,
	type CorrugateBrand,
	corrugateBrandSchema,
	type CorrugateConfiguration,
	getCorrugateConfigurationSchema,
} from "@/schemas";
import type { Flute } from "@/views/production/saved-jobs/types/dependencies";

import { packNetAxios } from "../lib/api-client";

export async function getAllBrands() {
	const response = await packNetAxios.get<CorrugateBrand[]>(`${baseRoutes.corrugate}/v1/corrugates/brands`);

	return response.data;
}

export const getCorrugates = async () => {
	const response = await packNetAxios.get<Corrugate[]>(`${baseRoutes.corrugate}/v1/corrugates`);

	return response.data;
};

export const getFlutes = async (): Promise<Flute[]> => {
	const response = await packNetAxios.get<Flute[]>(`${baseRoutes.corrugate}/v1/corrugates/flutes`);
	return response.data;
};

const corrugateBrandsSchema = z.array(corrugateBrandSchema);

export const getBrands = async (): Promise<CorrugateBrand[]> => {
	const response = await packNetAxios.get(`${baseRoutes.corrugate}/v1/corrugates/brands`);
	return corrugateBrandsSchema.enrich({ callSite: "getBrands" }).parseWithTelemetry(response.data);
};

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.corrugate}/v1/version`);
	return response.data;
}

export function createCorrugate(data: CorrugateConfiguration, intl: IntlShape): Promise<void> {
	return packNetAxios.post(
		`${baseRoutes.corrugate}/v1/corrugates`,
		getCorrugateConfigurationSchema(intl).enrich({ callSite: "createCorrugate" }).parseWithTelemetry(data),
	);
}

export function updateCorrugate(corrugateId: string, data: CorrugateConfiguration, intl: IntlShape): Promise<void> {
	return packNetAxios.put(
		`${baseRoutes.corrugate}/v1/corrugates/${corrugateId}`,
		getCorrugateConfigurationSchema(intl).enrich({ callSite: "updateCorrugate" }).parseWithTelemetry(data),
	);
}

export function deleteCorrugate(corrugateId: string): Promise<void> {
	return packNetAxios.delete(`${baseRoutes.corrugate}/v1/corrugates/${corrugateId}`);
}
